import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { loginRequest, setPermissions, setToken } from "../actions";
import {
  makeStyles,
  Grid,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import axios from "../api";
import Swal from "sweetalert2";
import HomeBackground from "../assets/img/Login_BG.png";
import Logo from "../assets/img/logocucv1.png";
import Backdrop from "../components/Backdrop";
import { useEffect } from "react";
import { auth, microsoftProvider } from "../data/firebase";
import { signInWithPopup } from "firebase/auth";

function SignIn(props) {
  const { user, loginRequest, setPermissions, setToken } = props;
  const history = useNavigate();
  const classes = useStyles();
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [authType, setAuthType] = useState("ldap");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (Object.keys(user || {}).length > 0) {
      if (user?.id_grupos_usuarios === 1 || user?.id_grupos_usuarios === 2) {
        history("/report");
      } else {
        history("/evaluation");
        window.location.reload();
      }
    }
  }, []);

  useEffect(() => {
    if (authType == "ldap") {
      setForm({
        ...form,
        usuario: "",
      });
    } else {
      setForm({
        ...form,
        email: "",
        password: "",
      });
    }
  }, [authType]);

  const handleInput = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (authType == "ldap") {
      if (form.usuario == undefined || form.usuario == "") {
        Swal.fire({
          icon: "error",
          text: "Ingrese un usuario.",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        console.log(
          "Iniciando Login Microsoft (vía Firebase) para:",
          form.usuario,
        );
        setLoading(true);
        try {
          // Configuramos el hint del usuario y el TENANT ID obligatorio
          microsoftProvider.setCustomParameters({
            tenant: "0507e5ce-0f95-49aa-abde-c90dcdedbd12",
            login_hint: form.usuario ? `${form.usuario}@cuc.edu.co` : "",
            prompt: "login",
          });

          const result = await signInWithPopup(auth, microsoftProvider);
          console.log("Resultado Firebase/Microsoft:", result);

          const idToken = await result.user.getIdToken();
          console.log("Firebase ID Token obtenido con éxito.");

          console.log("Enviando idToken al backend...");
          axios
            .post(`/user/signin`, { accessToken: idToken }) // Mantenemos el nombre del campo 'accessToken' si el back no lo cambió, o ajustamos a lo que el back pida
            .then((res) => {
              console.log("Respuesta Backend (Firebase):", res.data);
              if (res.data.user.success) {
                console.log("Login Exitoso. Redirigiendo...");
                loginRequest(res.data?.user?.user);
                setPermissions(res.data?.user?.permissions);
                setToken(res.data?.user?.token);
                if (
                  res.data?.user?.user?.id_grupos_usuarios === 1 ||
                  res.data?.user?.user?.id_grupos_usuarios === 2
                ) {
                  history("/report");
                } else {
                  history("/evaluation");
                  window.location.reload();
                }
                setLoading(false);
              } else {
                console.error(
                  "Error en Login (Backend):",
                  res.data.user.message,
                );
                Swal.fire({
                  icon: "error",
                  text: res.data?.user?.message,
                  showConfirmButton: false,
                  timer: 3000,
                });
                setLoading(false);
              }
            })
            .catch((err) => {
              console.error("Error crítico en axios post (Firebase):", err);
              setLoading(false);
            });
        } catch (authError) {
          console.error("Error en el Popup de Firebase:", authError);
          setLoading(false);
          Swal.fire({
            icon: "warning",
            text: "El inicio de sesión fue cancelado o la ventana fue cerrada.",
          });
        }
      }
    } else {
      console.log("Iniciando Login Local con Email:", form.email);
      setLoading(true);
      axios
        .post(`/user/signin`, form)
        .then((res) => {
          console.log("Respuesta Backend (Local):", res.data);
          if (res.data.user.success) {
            console.log("Login Exitoso. Redirigiendo...");
            loginRequest(res.data?.user?.user);
            setPermissions(res.data?.user?.permissions);
            setToken(res.data?.user?.token);
            if (
              res.data?.user?.user?.id_grupos_usuarios === 1 ||
              res.data?.user?.user?.id_grupos_usuarios === 2
            ) {
              history("/report");
            } else {
              history("/evaluation");
              window.location.reload();
            }
            setLoading(false);
          } else {
            console.error("Error en Login (Backend):", res.data.user.message);
            Swal.fire({
              icon: "error",
              text: res.data?.user?.message,
              showConfirmButton: false,
              timer: 3000,
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error crítico en axios post (Local):", error);
          setLoading(false);
          Swal.fire({
            icon: "error",
            text: "Usuario y/o contraseña incorrecta.",
            showConfirmButton: false,
            timer: 3000,
          });
        });
    }
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={12} className={classes.image}>
        <div className={classes.paper} style={{}}>
          <div>
            <img
              alt="logo"
              src={Logo}
              style={{ height: "90px", margin: "10px 0" }}
            />
          </div>
          <p className={classes.loginLabel}>Acceder</p>
          <form className={classes.form} onSubmit={handleSubmit}>
            <FormControl
              required
              fullWidth
              variant="outlined"
              className={classes.customOutlinedInput}
            >
              <InputLabel id="authLabel">Tipo de Autenticación</InputLabel>
              <Select
                labelId="authLabel"
                label="Tipo de Autenticación"
                value={authType}
                onChange={(e) => setAuthType(e.target.value)}
                inputProps={{
                  name: "authType",
                  id: "auth-type-input",
                }}
              >
                <MenuItem value={"ldap"}>Institucional</MenuItem>
                <MenuItem value={"local"}>Administrativo</MenuItem>
              </Select>
            </FormControl>
            {authType == "ldap" && (
              <TextField
                required
                fullWidth
                variant="outlined"
                margin="normal"
                label="Usuario"
                name="usuario"
                autoComplete="usuario"
                value={form.usuario}
                type="usuario"
                onChange={handleInput}
                InputProps={{
                  classes: {
                    root: classes.container__input_root,
                  },
                }}
              />
            )}
            {authType == "local" && (
              <>
                <TextField
                  required
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  label="Correo electrónico"
                  name="email"
                  autoComplete="email"
                  type="email"
                  onChange={handleInput}
                  InputProps={{
                    classes: {
                      root: classes.container__input_root,
                    },
                  }}
                />
                <TextField
                  required
                  fullWidth
                  variant="outlined"
                  margin="normal"
                  key="Contraseña"
                  label="Contraseña"
                  name="password"
                  autoComplete="current-password"
                  type={showPassword ? "text" : "password"}
                  onChange={handleInput}
                  InputProps={{
                    classes: {
                      root: classes.container__input_root,
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </>
            )}
            <Button
              color="primary"
              type="submit"
              variant="contained"
              className={classes.submit}
            >
              Iniciar sesión
            </Button>
          </form>
        </div>
      </Grid>
      <Backdrop loading={loading} />
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  anchor: {
    color: "#9d2d39",
    "&:hover": {
      color: "#9d2d39",
    },
  },
  image: {
    backgroundImage: `url(${HomeBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    padding: "5%",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      padding: "20px 15px",
      backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${HomeBackground})`,
    },
  },
  paper: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    width: "35%",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "450px",
      padding: "40px 24px",
      borderRadius: "28px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    },
    [theme.breakpoints.down(500)]: {
      width: "100%",
      borderRadius: "24px",
    },
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: "100%",
    maxWidth: "13em",
    fontWeight: "bold",
    borderRadius: "12px",
    height: "48px",
    backgroundColor: "#9d2d39",
    color: "white",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#82242e",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 12px rgba(157, 45, 57, 0.4)",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      height: "54px",
      fontSize: "16px",
    },
  },
  container__input_root: {
    borderRadius: "10px",
  },
  containerLogo: {
    margin: "-3em 0 3em 0",
  },
  textField: {
    margin: "11em 1em 0 1em",
    color: theme.palette.background.main,
    fontWeight: "bolder",
    fontSize: "42px",
    textShadow: "2px 2px 2px black",
    display: "none",
  },
  notchedOutline: {
    /* borderColor: "#9d2d39 !important", */
  },
  customOutlinedInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      borderColor: "#000 !important",
    },
  },
  color: {
    color: "#000 !Important",
  },
  loginLabel: {
    fontSize: "28px",
    fontWeight: "800",
    margin: "15px 0 25px 0",
    color: "#1e293b",
    width: "100%",
    textAlign: "center",
    position: "relative",
    display: "inline-block",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-8px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "35px",
      height: "4px",
      backgroundColor: "#9d2d39",
      borderRadius: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "26px",
      textAlign: "center",
    },
  },
}));

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToprops = {
  loginRequest,
  setPermissions,
  setToken,
};

export default connect(mapStateToProps, mapDispatchToprops)(SignIn);
